import Icon from "@/atoms/Icon";
import range from "lodash/range";
import { StyledTestimonial } from "./styles";
import useViewport from "utils/hooks/useViewport";
import { cleanImageURL } from "@literati/public-ui-shared-react";

const ResponsiveCroppedImg = ({ url, w, h, alt }) => {
  const cleanedUrl = cleanImageURL(url);
  const srcSet = [
    `${cleanedUrl}?w=${w}&h=${h}&fit=fill&f=faces&q=80 1x`,
    `${cleanedUrl}?w=${w * 2}&h=${h * 2}&fit=fill&f=faces&q=80 2x`,
  ].join(", ");
  return <img srcSet={srcSet} alt={alt} width={w} height={h} loading="lazy" />;
};

const Testimonial = ({ author, content, image }) => {
  const { screen } = useViewport();

  const imgDimensions = {
    xs: { w: 180, h: 125 },
    sm: { w: 232, h: 160 },
    md: { w: 220, h: 240 },
    lg: { w: 365, h: 440 },
  };

  const currentDimensions = imgDimensions[screen] || imgDimensions["lg"];

  return (
    <StyledTestimonial className={"slide-container"}>
      <div className="slide">
        <div className={"img-container"}>
          {image && currentDimensions && (
            <ResponsiveCroppedImg
              url={image.file.url}
              w={currentDimensions.w}
              h={currentDimensions.h}
              alt={image.file.description}
            />
          )}
        </div>
        <div className={"copy-container"}>
          <div className={"quote"}>“{content}”</div>
          <div className={"text-neo mb-1"}>
            {range(5).map((ix) => (
              <Icon
                key={`star-${ix}`}
                name="star-solid"
                size="1rem"
                className={"mr-1"}
              />
            ))}
          </div>
          <div className={"author"}>{author}</div>
        </div>
      </div>
    </StyledTestimonial>
  );
};

export default Testimonial;
